import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitTypeLabel',
  standalone: true,
})
export class UnitTypeLabelPipe implements PipeTransform {
  transform(bedrooms: number, bathrooms: number | null, isManager: boolean): string {
    if (isManager) return 'Manager';
    if (bedrooms === 0) return 'Studio';
    if (bathrooms === null) return `${bedrooms} bd`;
    return `${bedrooms} bd ${bathrooms} ba`;
  }
}
